import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,
    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator,
    Text,
    PermissionsAndroid,
    Linking, I18nManager,
    Image,

} from "react-native";


import {scale, moderateScale, verticalScale} from '../../../../tools/Scaling';


import HMActionBar from "../../../../customviews/HMActionBar";


import i18n from '../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import {Tools} from "../../../../tools/Tools";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import HMImageView from "../../../../customviews/HMImageView";
import {typeExport} from "../../../../redux/store/type";

import HMLoading from "../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import store from "../../../../redux/store";
import importFirebase from "../../../../importCalss/firebase/importFirebase";
import connect from "react-redux/es/connect/connect";
import HMIcon from "../../../../customviews/HMIcon";
import {
    callWebservice as callWebserviceSplash,
    serviceActionSetTimeSpan
} from "../../splash/action/ActionSplashSatiaScreen";
import HMSelectTimeFooter from "../../../../customviews/HMSelectTimeFooter";
import HMDialogSelectDate from "../../../../customviews/HMDialogSelectDate";

//import {ColorfulTabBar as TabBar} from 'react-navigation-tabbar-collection';
import {NavigationContainer} from '@react-navigation/native';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import ColorfulTabBar from "../../../../customviews/tabBar/collection/module/ColorfulTabBar/ColorfulTabBar";
import AddTaskOperationSatiaScreen from "./action/ActionAddTaskOperationSatiaScreen";
import ListReportTaskOperationSatiaScreen from "./action/ActionListReportTaskOperationSatiaScreen";
import ListTaskOperationSatiaScreen, {serviceActionError} from "./action/ActionListTaskOperationSatiaScreen";

const Tab = createBottomTabNavigator();


let container = null;

let firebase = importFirebase;

class TasksOperationSatiaScreen extends Component {


    constructor(props) {
        super(props);

        container = this;
        this.registerPushListener = pushNotification =>
            navigator.serviceWorker.addEventListener("message", ({data}) => {
                    const notificationTitle = data["firebase-messaging-msg-data"].notification.title;
                    const notificationOptions = {
                        body: data["firebase-messaging-msg-data"].notification.body,
                        icon: data["firebase-messaging-msg-data"].notification.icon,
                        logo: data["firebase-messaging-msg-data"].notification.icon,
                    };

                    // runtime.register().then(registration => {
                    //     registration.showNotification(notificationTitle, notificationOptions);
                    //
                    // })
                    if (Notification.permission === "granted") {
                        navigator.serviceWorker.ready.then(function (registration) {
                            container.getDataSplash();
                            //  global._refreshSplashSatia = true;
                            registration.showNotification(notificationTitle, notificationOptions
                                //     {
                                //     body: 'Buzz! Buzz!',
                                //     icon: PathFile.image.logo,
                                //     vibrate: [200, 100, 200, 100, 200, 100, 200],
                                //     tag: 'vibration-sample'
                                // }
                            );
                        });
                        // navigator.serviceWorker.getRegistration().then(reg => {
                        //     reg.showNotification(notificationTitle, notificationOptions);
                        // });
                    }


                }
            );
        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;


        }
        // switch (Platform.OS) {
        //
        //     case "android":
        //         firebase = require("react-native-firebase")
        //
        //         break;
        //     default:
        //
        // }
        // if (Platform.OS === "android") {
        //      firebase = require("react-native-firebase")
        //     // alert(firebase)
        //
        // }
        this.state = {
            columnCount: 2,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            alaki: false,
            viewportWidth: viewportWidth,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            DateTo: null,
            DateFrom: null,
        };
        this.props.navigation.addListener('focus', () => {

                this.setState({
                    alaki: !this.state.alaki,
                })
                container = this;


                if (global._refreshSplashSatiaOperator) {
                    global._refreshSplashSatiaOperator = false;
                    // let dataSplash = this.props.DataSplashSatiaScreen
                    //
                    // let paramss = {
                    //     "token": dataSplash.token,
                    //     "id": 1,
                    //     "lang": i18n.locale,
                    //     "imei": 0,
                    //     "token_fb": dataSplash.token_fb,
                    // };
                    // store.dispatch(callWebserviceSplash(Constants.urlGetSatia, paramss, Constants.TypeGetAllData, Constants._GET, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))
                    this.getDataSplash()
                }

            }
        )
        this.props.navigation.addListener('blur', () => {
        })


    }

    componentDidMount() {
        if (Platform.OS === "web" && 'Notification' in window && this.props.token_fb) {
            this.registerPushListener("")
        }

        if ((!global._loadDataCount) || !(this.props.DataSplashSatiaScreen.results && this.props.DataSplashSatiaScreen.results.status)) {
            this.getDataSplash();
        }
        else
            global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.documentElement.clientWidth;
                let viewportHeight = document.documentElement.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        viewportHeight: viewportHeight,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 600 ? 4 : 2,
                    },
                )


            })
        /*  if (Platform.OS === "android") {
              const channel = new firebase.notifications.Android.Channel(
                  '1',
                  'A',
                  firebase.notifications.Android.Importance.Max
              ).setDescription('A natural description of the channel');
              firebase.notifications().android.createChannel(channel);

              // the listener returns a function you can use to unsubscribe
              this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                  //  alert("yyyy")
                  if (Platform.OS === 'android') {
                      const localNotification = new firebase.notifications.Notification({
                          sound: 'default',
                          show_in_foreground: true,
                      }).setNotificationId(notification.notificationId)
                          .setTitle(notification.title)
                          .setSubtitle(notification.subtitle)
                          .setBody(notification.body)
                          .setData(notification.data)
                          .android.setChannelId('channelId') // e.g. the id you chose above
                          .android.setSmallIcon('logo') // create this icon in Android Studio
                          .android.setLargeIcon('logo') // create this icon in Android Studio
                          // .android.setColor('#ee3d43') // you can set a color here
                          .android.setPriority(firebase.notifications.Android.Priority.High);

                      firebase.notifications()
                          .displayNotification(localNotification)
                          .catch(err => console.error(err));

                  }
                  else if (Platform.OS === 'ios') {

                      const localNotification = new firebase.notifications.Notification()
                          .setNotificationId(notification.notificationId)
                          .setTitle(notification.title)
                          .setSubtitle(notification.subtitle)
                          .setBody(notification.body)
                          .setData(notification.data)
                          .ios.setBadge(notification.ios.badge);

                      firebase.notifications()
                          .displayNotification(localNotification)
                          .catch(err => console.error(err));
                  }


                  if (notification && notification.data && notification.data.typeOperation === '1') {
                      let item = null

                      if (notification.data.menu) {
                          item = JSON.parse(notification.data.menu.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                          if (item.length > 0) {
                              global.list_menu_shahrdar = item;
                              this.setState({alaki: !this.state.alaki})

                          }
                      }
                  }

              });
              // if (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
              //     this.getData()

          }*/
        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.getDataSplash)

    }

    changeMenu() {
        container.setState({alaki: !container.state.alaki})
    }

    getData() {
        let {mobile, password} = this.state;

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": typeExport._GetCalendar,
            "lang": i18n.locale,

            //    "username": mobile,
            //  "password": password,
            //
            // "username": Tools.persianToEnglish(mobile),
            // "password": Tools.persianToEnglish(password),
            // "token_fb": this.props.DataSplashScreen.token_fb,
        };

        this.props.callService(
            typeExport.urlTasksOperationSatiaScreen,
            paramss,
            typeExport.TypeGetTasksOperationSatiaScreen,
            "POST",
            this.state
        );

    }

    componentWillUnmount() {
        if (Platform.OS === "web" && 'Notification' in window && this.props.token_fb) {
            this.registerPushListener("")
        }
        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
        }
    }

    _setStateData(object) {

        object.DateFrom && store.dispatch(serviceActionSetTimeSpan(object.DateFrom, object.DateTo, object.indexSelectMonthType, null));

        container.setState(object);
    }

    setDate(DateFrom, DateTo) {
        store.dispatch(serviceActionSetTimeSpan(DateFrom, DateTo, 3, null))
        container.setState({
                DateFrom, DateTo, showDialogDate: false,
                indexSelectMonthType: container.state.indexSelectMonthTypePrevious,

            },
            () => {
                container.getDataSplash()
            }
        )
    }

    render() {
        let {viewportWidth, viewportHeight} = this.state;
        let request_server = this.props.route.params ? this.props.route.params.request_server : null
        let item = this.props.route.params ? this.props.route.params.item : null

        let {beginDate, endDate, indexSelectMonthType} = this.props.DataSplashSatiaScreen;

        let dataList = this.props.DataSplashSatiaScreen.results.menus ? this.props.DataSplashSatiaScreen.results.menus : [];

        /*     let dataList = [
                 {
                     name: 'ثبت وظایف جدید',
                     description: 'ثبت وظایف جدید',

                     image: 'http://192.168.57.2/images/icons/new_task.png',
                     //image_source:  PathFile.image.sabt_darkhast,
                     //  image_source: (PathFile.image.sabt_darkhast),
                     typeClick: 1,
                     type: 1,
                 },
                 {
                     name: 'وظایف من',
                     description: 'وظایف در دست اقدام (1)',
                     image: 'http://192.168.57.2/images/icons/my_task.png',
                     // image_source: PathFile.image.Natije_Darkhast,
                     // image_source: (PathFile.image.Natije_Darkhast),

                     typeClick: 2,
                     type: 2,
                 },
                 {
                     name: 'وظایف انجام شده',
                     description: 'وظایف انجام شده توسط من (0)',
                     image: 'http://192.168.57.2/images/icons/done_task.png',
                     //image_source: PathFile.image.Sabt_Shekayat,
                     // image_source: (PathFile.image.Sabt_Shekayat),

                     typeClick: 2,
                     type: 3,
                 },
                 {
                     name: 'وظایف ایجاد شده',
                     description: 'وظایف ایجاد شده توسط من',
                     image: 'http://192.168.57.2/images/icons/created_task.png',
                     //   image_source: (PathFile.image.Natije_Shekayat),

                     // image_source: PathFile.image.Natije_Shekayat,
                     typeClick: 2,
                     type: 4,
                 },
                 {
                     name: 'گزارش وظایف',
                     description: 'ریز گزارش وظایف',
                     image: 'http://192.168.57.2/images/icons/created_task.png',
                     //image_source: PathFile.image.Sabt_Shekayat,
                     // image_source: (PathFile.image.Sabt_Shekayat),

                     typeClick: 2,
                     type: 5,
                 },
                 {
                     name: 'رونوشت وظایف',
                     description: 'وظایف رونوشت شده (1)',
                     image: 'http://192.168.57.2/images/icons/my_task.png',
                     //   image_source: (PathFile.image.Natije_Shekayat),

                     // image_source: PathFile.image.Natije_Shekayat,
                     typeClick: 2,
                     type: 6,
                 },
             ]
     */
        return (
            <View style={{position: 'relative', flex: 1}}>

                {
                    1 !== 1 ?
                        <NavigationContainer
                            independent={true} theme={{
                            colors: {
                                background: '#8bbbff',
                            },
                        }}>
                            <Tab.Navigator
                                initialRouteName="Home"
                                screenOptions={{
                                    headerShown: false, tabBarActiveBackgroundColor: "blue",


                                }}
                                // tabBarOptions={{
                                //     activeTintColor: Colors.primaryColor,
                                //     inactiveTintColor: 'black',
                                // }}
                                // screenOptions={({route}) => ({
                                //     tabBarIcon: ({color}) => {
                                //         const size = 24;
                                //
                                //         if (route.name === 'Home') {
                                //             return <HMIcon name={'home'} style={{color: color}}
                                //                            size={size} color={color}/>;
                                //         } else if (route.name === 'News') {
                                //             return <HMIcon name={'md-settings-sharp'} style={{color: color}}
                                //                            size={size} color={color}/>;
                                //         } else if (route.name === 'Chat') {
                                //             return <HMIcon name={'ellipsis-horizontal-circle'} style={{color: color}}
                                //                            size={size} color={color}/>;
                                //         } else if (route.name === 'Likes') {
                                //             return <HMIcon name={'md-analytics'} size={size} style={{color: color}}
                                //                            color={color}/>;
                                //         } else if (route.name === 'Settings') {
                                //             return <HMIcon name={'settings'} size={size} style={{color: color}}
                                //                            color={color}/>;
                                //         }
                                //
                                //     },
                                //     tabBarActiveTintColor: '#5bee00',
                                //     tabBarInactiveTintColor: '#ee3535',
                                //     tabBarActiveBackgroundColor: '#0056ee',
                                //     tabBarInactiveBackgroundColor: '#eec23a',
                                //     tabBarStyle: {
                                //         borderTopColor: '#0feee8',
                                //     }
                                // })}
                                //
                                // tabBarOptions={{
                                //     activeTintColor: '#fff',
                                //     inactiveTintColor: 'lightgray',
                                //     activeBackgroundColor: '#c4461c',
                                //     inactiveBackgroundColor: '#b55031',
                                //     style: {
                                //         backgroundColor: '#CE4418',
                                //         paddingBottom: 3
                                //     }
                                // }}
                                // activeColor="#00aea2"
                                // inactiveColor="#95a5a6"
                                // screenOptions={({ route }) => ({
                                //     if (route.name === 'Home') {
                                //     this.tabIndex=4;
                                // } else if (route.name === 'Settings') {
                                //     this.tabIndex=5;
                                // }
                                // })}
                                // tabBarOptions={{
                                //     style: {
                                //         height: '9%',
                                //         backgroundColor: 4 == 4 ? "#ff0055" : "#24ee16",
                                //         //backgroundColor: 'transparent',
                                //         position: 'absolute',
                                //         bottom: 0,
                                //         elevation: 0
                                //     },
                                //     activeTintColor: '#000000',
                                //     showLabel: false,
                                // }}
                                tabBar={(props) =>
                                    <View style={{width: "100%",}}>
                                        <ColorfulTabBar
                                            {...props}
                                            colorPalette={{
                                                primary: "#5b37b7",
                                                secondary: "#6c757d",
                                                success: "#198754",
                                                danger: "#c9379d",
                                                warning: "#e6a919",
                                                info: "#00bcd4",
                                                light: "#ffffff",       //Background Color
                                                dark: "#212529",        //Foreground Color
                                            }}
                                            // darkMode={false}
                                            openIcon={({color, size}) => <HMIcon type="AntDesign" name="appstore-o"
                                                                                 style={{color: color}}
                                                                                 size={size}
                                                                                 color={color}

                                            />}
                                            closeIcon={({color, size}) => <HMIcon type="AntDesign" name="close"
                                                                                  size={size}
                                                                                  style={{color: color}}
                                                                                  color={color}

                                            />}
                                        />
                                    </View>
                                }
                            >
                                <Tab.Screen
                                    name="Home"
                                    component={DemoScreen}
                                    options={{
                                        title: 'Home',
                                        icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="home"
                                                                                  size={size} color={color}

                                                                                  style={{color: color}}
                                        />,
                                        color: '#808b37',
                                    }}
                                />
                                <Tab.Screen
                                    name="News"
                                    component={DemoScreen}
                                    options={{
                                        title: 'News',
                                        icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="sharealt"
                                                                                  size={size}
                                                                                  color={color}
                                                                                  style={{color: color}}

                                        />,
                                        color: 'info',
                                    }}
                                />
                                <Tab.Screen
                                    name="Chat"
                                    component={DemoScreen}
                                    options={{
                                        title: 'Chat',
                                        icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="API"
                                                                                  size={size} color={color}
                                                                                  style={{color: color}}

                                        />,
                                        color: 'warning',
                                    }}
                                />
                                <Tab.Screen
                                    name="Likes"
                                    component={DemoScreen}
                                    options={{
                                        title: 'Likes',
                                        icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="hearto"
                                                                                  size={size}
                                                                                  color={color}
                                                                                  style={{color: color}}

                                        />,
                                        color: 'danger',
                                    }}
                                />
                                <Tab.Screen
                                    name="Settings"
                                    component={DemoScreen}
                                    options={{
                                        title: 'Settings',
                                        icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="setting"
                                                                                  size={size}
                                                                                  color={color}
                                                                                  style={{color: color}}

                                        />,
                                        color: 'success',
                                    }}
                                />
                                <Tab.Screen
                                    name="Likes1"
                                    component={DemoScreen}
                                    options={{
                                        title: 'Likes1',
                                        icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="hearto"
                                                                                  size={size}
                                                                                  color={color}
                                                                                  style={{color: color}}

                                        />,
                                        color: 'danger',
                                    }}
                                />
                                <Tab.Screen
                                    name="Settings1"
                                    component={DemoScreen}
                                    options={{
                                        title: 'Settings1',
                                        icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="setting"
                                                                                  size={size}
                                                                                  color={color}
                                                                                  style={{color: color}}

                                        />,
                                        color: 'success',
                                    }}
                                />
                            </Tab.Navigator>
                        </NavigationContainer>
                        :
                        <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                            <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                                  enabled={Platform.OS === "ios"}>
                                <HMActionBar
                                    //  menu={!checkLogin}
                                    menu
                                    // back
                                    exit={true}

                                    props={this.props} statusBarTransparent
                                    //  text={i18n.t('Apply.title')}
                                    // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family : null}
                                    text={item ? (item.name ? item.name : (item.title ? item.title : 'وظایف')) : "وظایف"}
                                    //  text={i18n.t('constant.Information')}

                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}
                                    // funcExit={checkLogin ? () => {
                                    //
                                    //     HMAlert(
                                    //         i18n.t('constant.message'),
                                    //         "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                                    //         [
                                    //             // {text: 'Ask me later', onPress: () => {}},
                                    //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                    //             {
                                    //                 text: i18n.t('constant.ok'), onPress: () => {
                                    //                     AsyngStorageClass.removeToken(typeExport._Shahrdar);
                                    //                 }
                                    //             },
                                    //         ],
                                    //         {cancelable: true}
                                    //     )
                                    //
                                    //
                                    //     // Tools.remove()
                                    //     // NavigationService.resetTo("SplashScreen")
                                    // } : null}
                                    // styleText={[ {marginStart: moderateScale(48)}]}
                                    funcExit={() => Tools.exitApp()}
                                />
                                <HMSelectTimeFooter
                                    DateTo={endDate}
                                    DateFrom={beginDate}
                                    //  arraySelected={this.state.arraySelected}
                                    indexSelectMonthType={indexSelectMonthType}
                                    showDialogDate={this.state.showDialogDate}
                                    func={() => this.getDataSplash()}
                                    _setStateData={container._setStateData}
                                />

                                {
                                    !this.props.DataSplashSatiaScreen.isLoading && this.props.DataSplashSatiaScreen.results && !this.props.DataSplashSatiaScreen.NoInternetDialog ?
                                        null
                                        :
                                        <View
                                            style={{
                                                width: "100%",
                                                //  flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                backgroundColor: this.props.DataSplashSatiaScreen.NoInternetDialog ? Colors.red : Colors.white,
                                                alignSelf: 'center',
                                                padding: moderateScale(6)
                                            }}
                                        >
                                            {this.props.DataSplashSatiaScreen.NoInternetDialog ?
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        flexDirection: 'row',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',

                                                    }}>


                                                    <HMTextView
                                                        type={"bold"}

                                                        style={[
                                                            {
                                                                // position: 'absolute',
                                                                //  bottom: 0,
                                                                // height: moderateScale(44),
                                                                // width: '100%',
                                                                textAlign: "center",
                                                                color: Colors.white,
                                                                fontSize: moderateScale(11),
                                                                //  padding: moderateScale(1),

                                                                // backgroundColor: 'rgba(0,0,0,0.25)',
                                                            }]}
                                                        numberOfLines={2}
                                                        text={"خطایی رخ داده مجددا تلاش نمایید"}
                                                    />
                                                    <View style={{width: moderateScale(4)}}/>
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            this.getDataServerSplash()

                                                        }}
                                                        style={{
                                                            // flex: .33,
                                                            // width: '92%',
                                                            // height: moderateScale(28),
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            backgroundColor: Colors.yellow,
                                                            borderRadius: moderateScale(6),
                                                            marginHorizontal: moderateScale(2),
                                                            paddingHorizontal: moderateScale(4),
                                                            paddingVertical: moderateScale(2),


                                                        }}>

                                                        <HMTextView
                                                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                            text={i18n.t('constant.Update')}
                                                            //  text={"ثبت و بستن تیکت"}
                                                            type={"bold"}
                                                            style={{
                                                                fontSize: moderateScale(10),
                                                                marginVertical: moderateScale(2),
                                                                //     marginHorizontal: moderateScale(4),
                                                                color: Colors.white
                                                            }}/>
                                                    </TouchableOpacity>

                                                </View>
                                                :

                                                <View
                                                    style={{
                                                        width: "100%",
                                                        flexDirection: 'row',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',

                                                    }}>


                                                    <HMTextView
                                                        type={"bold"}

                                                        style={[
                                                            {
                                                                // position: 'absolute',
                                                                //  bottom: 0,
                                                                // height: moderateScale(44),
                                                                // width: '100%',
                                                                textAlign: "center",
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(11),
                                                                //  padding: moderateScale(1),

                                                                // backgroundColor: 'rgba(0,0,0,0.25)',
                                                            }]}
                                                        numberOfLines={2}
                                                        text={i18n.t('constant.Update')}
                                                    />
                                                    <View style={{width: moderateScale(4)}}/>
                                                    <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>

                                                </View>
                                            }
                                        </View>


                                }
                                <View style={{flex: 1, alignItems: 'center'}}>
                                    <TouchableOpacity
                                        style={{
                                            flexDirection: 'row',
                                            backgroundColor: Colors.white,
                                            borderRadius: moderateScale(6),
                                            width: '98%',
                                            alignSelf: "center",
                                            height: moderateScale(40),
                                            marginTop: moderateScale(8)
                                            // marginHorizontal:moderateScale(10)

                                        }}

                                        // onPress={() => {
                                        //     NavigationService.navigateParams("ShowMap", {
                                        //         myLocation: true,
                                        //         //showPlace: true,
                                        //         position: {
                                        //             coords: {
                                        //                 latitude: "34.084652", longitude: "49.688403"
                                        //             }
                                        //         },
                                        //         _setStateData: container._setStateData,
                                        //         checkSelectLocation: true,
                                        //
                                        //     })
                                        // }}
                                        onPress={() => {
                                            let obj = {
                                                "name": 'جستجو',
                                                "description": null,
                                                //"image" : 'http://192.168.57.2/images/icons/created_task.png',
                                                "typeClick": null,
                                                "type": null,
                                            };
                                            NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
                                                Extras: obj,
                                                // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
                                                data: obj, item: obj,
                                            })
                                        }}
                                    >
                                        <View style={{
                                            width: moderateScale(30),
                                            height: "100%",
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <HMIcon
                                                //type={"Feather"}
                                                name="search"
                                                style={{
                                                    color: Colors.colorDarker,
                                                    fontSize: moderateScale(18),
                                                    //  padding: moderateScale(4),
                                                    alignSelf: "center",
                                                }}/>

                                        </View>
                                        <View style={{
                                            flex: 1,
                                            justifyContent: 'center',
                                            paddingHorizontal: moderateScale(2)
                                        }}>
                                            <HMTextView
                                                text={"وظیفه مورد نظر خود را جستجو کنید"}
                                                //  text={"وظیفه مورد نظر خود را جستجو کنید" + "  _  " + this.state.R_latitude + "  _  " + this.state.R_longitude+ "  _  " + this.state.R_address}
                                                style={{color: Colors.gray, fontSize: moderateScale(13)}}/>
                                        </View>
                                        <View style={{
                                            width: moderateScale(30),
                                            height: "100%",
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <HMIcon
                                                //type={"Feather"}
                                                name="filter"
                                                style={{
                                                    color: Colors.colorDarker,
                                                    fontSize: moderateScale(18),
                                                    //  padding: moderateScale(4),
                                                    alignSelf: "center",
                                                }}/>
                                        </View>

                                    </TouchableOpacity>
                                    {
                                        this.props.results == null && this.props.isLoading && request_server ?
                                            <HMLoading/>

                                            :

                                            (
                                                1 === 1 ?
                                                    <ScrollView
                                                        style={{
                                                            //   backgroundColor:"#dd2dee"
                                                        }}>
                                                        <View
                                                            style={{
                                                                //position:'absolute',
                                                                flexDirection: "row",
                                                                flexWrap: 'wrap',
                                                                flex: 1,

                                                                flexGrow: 1,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginTop: moderateScale(12)
                                                                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                                                //  backgroundColor: "#876a79",
                                                            }}>


                                                            {
                                                                dataList && dataList.length > 0 ?
                                                                    dataList.map((item, key) => {
                                                                        //  (this.state.data).find((obj) => obj.locale == i18n.locale).list.map((item, key) => {
                                                                        return (
                                                                            //type=0 => پیوند ,type=1 => اخبار ,type=2 => صفحه ,type=3 => منو ,type=4 => اسلایدر ,type=5 => 137 یار ,type=6 => نقشه ,,type=7 => شکایات ,,type=8 =>  ارامستان ,
                                                                            <TouchableOpacity
                                                                                key={key + "iii"}
                                                                                onPress={() => {
                                                                                    switch (item.type) {

                                                                                        case 1:
                                                                                            // Toast.show({
                                                                                            //     text1: 'Hello',
                                                                                            //     text2: 'This is some something 👋'
                                                                                            // })                                                                            //alert(global.ref_toast)

                                                                                            NavigationService.navigateParams("AddTaskOperationSatiaScreen", {
                                                                                                //  NavigationService.navigateParams("ListUserChatScreen", {
                                                                                                // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
                                                                                                data: item,
                                                                                                item: item,
                                                                                                Extras: item,
                                                                                            })
                                                                                            break;

                                                                                        case 2:
                                                                                            NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
                                                                                                Extras: item,
                                                                                                // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
                                                                                                data: item, item: item,
                                                                                            })
                                                                                            break;
                                                                                        case 3:
                                                                                            NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
                                                                                                Extras: item,
                                                                                                // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
                                                                                                data: item, item: item,
                                                                                            })
                                                                                            break;

                                                                                        case 4:
                                                                                            NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
                                                                                                Extras: item,
                                                                                                // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
                                                                                                data: item, item: item,
                                                                                            })
                                                                                            break;

                                                                                        case 5:
                                                                                            // alert("djhbghb")

                                                                                            NavigationService.navigateParams("ListReportTaskOperationSatiaScreen", {
                                                                                                Extras: item,
                                                                                                // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
                                                                                                data: item, item: item,
                                                                                            })
                                                                                            break;
                                                                                        case 6:

                                                                                            NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
                                                                                                Extras: item,
                                                                                                // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
                                                                                                data: item, item: item,
                                                                                            })
                                                                                            break;


                                                                                        default:
                                                                                    }


                                                                                }}
                                                                                style={{
                                                                                    // width: "100%",

                                                                                    //  width: '100%',
                                                                                    //  flex:1,
                                                                                    height: this.state.itemWidth / 2 + moderateScale(10),
                                                                                    marginHorizontal: moderateScale(4),
                                                                                    marginBottom: moderateScale(4),
                                                                                    borderRadius: moderateScale(6),
                                                                                    borderColor: '#d0d8df',
                                                                                    backgroundColor: Colors.white,
                                                                                    borderWidth: moderateScale(1),
                                                                                    //  marginVertical: moderateScale(2),
                                                                                    // padding: moderateScale(6)
                                                                                }}>
                                                                                <View
                                                                                    style={{
                                                                                        flex: .65,
                                                                                        width: this.state.itemWidth / 2 - moderateScale(18),
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}>

                                                                                    <View
                                                                                        style={{
                                                                                            width: this.state.itemWidth / 6,
                                                                                            height: this.state.itemWidth / 6,
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            item.image_source ?
                                                                                                <HMImageView
                                                                                                    // resizeMode={FastImage.resizeMode.contain}
                                                                                                    resizeMode={"contain"}
                                                                                                    _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}
                                                                                                    //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                                    // uriComplete={item.image}
                                                                                                    source_image={item.image_source}
                                                                                                    styleText={{marginTop: moderateScale(10)}}
                                                                                                    borderRadius={4}/>
                                                                                                :
                                                                                                <HMImageView
                                                                                                    // resizeMode={FastImage.resizeMode.contain}
                                                                                                    resizeMode={"contain"}
                                                                                                    _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                                                                                    //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                                    uriComplete={item.image}
                                                                                                    //source_image={item.image}
                                                                                                    styleText={{marginTop: moderateScale(10)}}
                                                                                                    borderRadius={4}/>
                                                                                        }
                                                                                    </View>
                                                                                    {
                                                                                        item.countUnreadMessage ?
                                                                                            <View
                                                                                                style={{
                                                                                                    position: 'absolute',
                                                                                                    top: 0,
                                                                                                    left: 0,
                                                                                                    backgroundColor: Colors.red,
                                                                                                    height: moderateScale(36),
                                                                                                    width: moderateScale(36),
                                                                                                    borderRadius: moderateScale(18),
                                                                                                    margin: moderateScale(4),
                                                                                                    alignItems: 'center',
                                                                                                    justifyContent: 'center'
                                                                                                }}>

                                                                                                <HMTextView
                                                                                                    numberOfLines={1}
                                                                                                    type={"bold"}
                                                                                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                                                    text={item.countUnreadMessage}

                                                                                                    style={{
                                                                                                        fontSize: moderateScale(12),

                                                                                                        color: Colors.white,


                                                                                                        //  textAlign: "right",
                                                                                                    }}/>

                                                                                            </View>
                                                                                            :
                                                                                            null
                                                                                    }
                                                                                </View>

                                                                                <View style={{
                                                                                    flex: .35,
                                                                                    backgroundColor: "#f4f4f4",
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    borderTopColor: '#d0d8df',
                                                                                    borderBottomColor: Colors.transparent,
                                                                                    borderRightColor: Colors.transparent,
                                                                                    borderLeftColor: Colors.transparent,
                                                                                    borderWidth: moderateScale(1),
                                                                                }}>
                                                                                    <HMTextView
                                                                                        numberOfLines={2}
                                                                                        type={"bold"}
                                                                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                                        text={item.name}
                                                                                        style={{
                                                                                            fontSize: moderateScale(14),

                                                                                            color: Colors.colorDark,
                                                                                            marginTop: moderateScale(4),
                                                                                            //  textAlign: "right",
                                                                                        }}/>
                                                                                    <HMTextView
                                                                                        numberOfLines={2}
                                                                                        // type={"bold"}
                                                                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                                        text={item.description}
                                                                                        style={{
                                                                                            fontSize: moderateScale(12),

                                                                                            color: Colors.colorDark,
                                                                                            marginTop: moderateScale(4),
                                                                                            //  textAlign: "right",
                                                                                        }}/>
                                                                                </View>
                                                                                {/*   {
                                                                    item.countUnreadMessage ?
                                                                        <TouchableOpacity
                                                                            onPress={() => {
                                                                                this.setState({
                                                                                    showDialogDate: true
                                                                                })
                                                                            }}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: 0,
                                                                                overflow: 'hidden',
                                                                                width: moderateScale(44),
                                                                                height: moderateScale(44),
                                                                                borderRadius: moderateScale(22),
                                                                                // padding: moderateScale(4),
                                                                                margin: moderateScale(5),
                                                                                borderWidth: moderateScale(1),
                                                                                borderColor: '#ddd',
                                                                                borderBottomWidth: 0,
                                                                                shadowColor: '#000',
                                                                                shadowOffset: {
                                                                                    width: 0,
                                                                                    height: moderateScale(.7)
                                                                                },
                                                                                shadowOpacity: 0.6,
                                                                                shadowRadius: moderateScale(2),
                                                                                elevation: moderateScale(1),
                                                                                // marginLeft: moderateScale(1),
                                                                                // marginRight: moderateScale(1),
                                                                                // marginTop: moderateScale(1),
                                                                                // marginBottom: moderateScale(1),
                                                                                backgroundColor: Colors.red,
                                                                                alignItems: 'center',
                                                                                justifyContent: "center",
                                                                                zIndex: 1
                                                                            }}>
                                                                            <HMTextView
                                                                                numberOfLines={2}
                                                                                type={"bold"}
                                                                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                                text={item.countUnreadMessage}
                                                                                style={{
                                                                                    fontSize: moderateScale(14),

                                                                                    color: Colors.white,
                                                                                    marginTop: moderateScale(4),
                                                                                    //  textAlign: "right",
                                                                                }}/>
                                                                        </TouchableOpacity>
                                                                        :
                                                                        null
                                                                }*/}


                                                                            </TouchableOpacity>
                                                                        ) //if you have a bunch of keys value pair

                                                                    })
                                                                    :
                                                                    null

                                                            }
                                                        </View>
                                                    </ScrollView>
                                                    :
                                                    <View style={{width: "100%", flex: 1}}>
                                                        <Tab.Navigator
                                                            initialRouteName="Home"
                                                            screenOptions={{
                                                                headerShown: false,
                                                                tabBarActiveBackgroundColor: "blue",


                                                            }}

                                                            // tabBarOptions={{
                                                            //     activeTintColor: Colors.primaryColor,
                                                            //     inactiveTintColor: 'black',
                                                            // }}
                                                            // screenOptions={({route}) => ({
                                                            //     tabBarIcon: ({color}) => {
                                                            //         const size = 24;
                                                            //
                                                            //         if (route.name === 'Home') {
                                                            //             return <HMIcon name={'home'} style={{color: color}}
                                                            //                            size={size} color={color}/>;
                                                            //         } else if (route.name === 'News') {
                                                            //             return <HMIcon name={'md-settings-sharp'} style={{color: color}}
                                                            //                            size={size} color={color}/>;
                                                            //         } else if (route.name === 'Chat') {
                                                            //             return <HMIcon name={'ellipsis-horizontal-circle'} style={{color: color}}
                                                            //                            size={size} color={color}/>;
                                                            //         } else if (route.name === 'Likes') {
                                                            //             return <HMIcon name={'md-analytics'} size={size} style={{color: color}}
                                                            //                            color={color}/>;
                                                            //         } else if (route.name === 'Settings') {
                                                            //             return <HMIcon name={'settings'} size={size} style={{color: color}}
                                                            //                            color={color}/>;
                                                            //         }
                                                            //
                                                            //     },
                                                            //     tabBarActiveTintColor: '#5bee00',
                                                            //     tabBarInactiveTintColor: '#ee3535',
                                                            //     tabBarActiveBackgroundColor: '#0056ee',
                                                            //     tabBarInactiveBackgroundColor: '#eec23a',
                                                            //     tabBarStyle: {
                                                            //         borderTopColor: '#0feee8',
                                                            //     }
                                                            // })}
                                                            //
                                                            // tabBarOptions={{
                                                            //     activeTintColor: '#fff',
                                                            //     inactiveTintColor: 'lightgray',
                                                            //     activeBackgroundColor: '#c4461c',
                                                            //     inactiveBackgroundColor: '#b55031',
                                                            //     style: {
                                                            //         backgroundColor: '#CE4418',
                                                            //         paddingBottom: 3
                                                            //     }
                                                            // }}
                                                            // activeColor="#00aea2"
                                                            // inactiveColor="#95a5a6"
                                                            // screenOptions={({ route }) => ({
                                                            //     if (route.name === 'Home') {
                                                            //     this.tabIndex=4;
                                                            // } else if (route.name === 'Settings') {
                                                            //     this.tabIndex=5;
                                                            // }
                                                            // })}
                                                            // tabBarOptions={{
                                                            //     style: {
                                                            //         height: '9%',
                                                            //         backgroundColor: 4 == 4 ? "#ff0055" : "#24ee16",
                                                            //         //backgroundColor: 'transparent',
                                                            //         position: 'absolute',
                                                            //         bottom: 0,
                                                            //         elevation: 0
                                                            //     },
                                                            //     activeTintColor: '#000000',
                                                            //     showLabel: false,
                                                            // }}
                                                            tabBar={(props) =>
                                                                <View style={{width: "100%",}}>
                                                                    <ColorfulTabBar
                                                                        {...props}
                                                                        colorPalette={{
                                                                            primary: "#5b37b7",
                                                                            secondary: "#6c757d",
                                                                            success: "#198754",
                                                                            danger: "#c9379d",
                                                                            warning: "#e6a919",
                                                                            info: "#00bcd4",
                                                                            light: "#ffffff",       //Background Color
                                                                            dark: "#212529",        //Foreground Color
                                                                        }}
                                                                        // darkMode={false}
                                                                        openIcon={({color, size}) => <HMIcon
                                                                            type="AntDesign" name="appstore-o"
                                                                            style={{color: color}}
                                                                            size={size}
                                                                            color={color}

                                                                        />}
                                                                        closeIcon={({color, size}) => <HMIcon
                                                                            type="AntDesign" name="close"
                                                                            size={size}
                                                                            style={{color: color}}
                                                                            color={color}

                                                                        />}
                                                                    />
                                                                </View>
                                                            }
                                                        >
                                                            {
                                                                dataList && dataList.length > 0 ?
                                                                    dataList.map((item, key) => {
                                                                        //  (this.state.data).find((obj) => obj.locale == i18n.locale).list.map((item, key) => {
                                                                        return (
                                                                            //type=0 => پیوند ,type=1 => اخبار ,type=2 => صفحه ,type=3 => منو ,type=4 => اسلایدر ,type=5 => 137 یار ,type=6 => نقشه ,,type=7 => شکایات ,,type=8 =>  ارامستان ,
                                                                            <Tab.Screen
                                                                                name={"ahmad_" + key}
                                                                                // component={<AddTaskOperationSatiaScreen Extras={item}
                                                                                //                                         data={item} item={item}
                                                                                // />}
                                                                                //
                                                                                listeners={({navigation}) => ({
                                                                                    tabPress: (e) => {
                                                                                        // Prevent default action
                                                                                        //  e.preventDefault();
                                                                                        //navigation.navigate("PhotoNavigation"); // Here!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                                                                                    },
                                                                                })}
                                                                                children={({navigation, route}) => {
                                                                                    return this.switchComponents(item, key, navigation, route);
                                                                                    // return <AddTaskOperationSatiaScreen
                                                                                    //     data={item} item={item}
                                                                                    //     Extras={item}/>
                                                                                }
                                                                                }

                                                                                options={{
                                                                                    title: item.name,
                                                                                    tabBarIcon: ({size, focused, color}) => {
                                                                                        return (
                                                                                            <Image
                                                                                                style={{
                                                                                                    width: size,
                                                                                                    height: size
                                                                                                }}
                                                                                                source={{
                                                                                                    uri:
                                                                                                    item.image,
                                                                                                }}
                                                                                            />
                                                                                        );
                                                                                    },
                                                                                    /*      icon: ({focused, color, size}) =>
                                                                                              <HMIcon
                                                                                                  type="AntDesign"
                                                                                                  name="setting"
                                                                                                  size={size}
                                                                                                  color={color}
                                                                                                  style={{color: color}}

                                                                                              />,*/
                                                                                    color: 'success',
                                                                                }}
                                                                            />
                                                                        ) //if you have a bunch of keys value pair

                                                                    })
                                                                    :
                                                                    null

                                                            }


                                                            {/*    <Tab.Screen
                                                                    name="Home"
                                                                    component={DemoScreen}
                                                                    options={{
                                                                        title: 'Home',
                                                                        icon: ({focused, color, size}) => <HMIcon
                                                                            type="AntDesign" name="home"
                                                                            size={size} color={color}

                                                                            style={{color: color}}
                                                                        />,
                                                                        color: '#808b37',
                                                                    }}
                                                                />
                                                                <Tab.Screen
                                                                    name="News"
                                                                    component={DemoScreen}
                                                                    options={{
                                                                        title: 'News',
                                                                        icon: ({focused, color, size}) => <HMIcon
                                                                            type="AntDesign" name="sharealt"
                                                                            size={size}
                                                                            color={color}
                                                                            style={{color: color}}

                                                                        />,
                                                                        color: 'info',
                                                                    }}
                                                                />
                                                                <Tab.Screen
                                                                    name="Chat"
                                                                    component={DemoScreen}
                                                                    options={{
                                                                        title: 'Chat',
                                                                        icon: ({focused, color, size}) => <HMIcon
                                                                            type="AntDesign" name="API"
                                                                            size={size} color={color}
                                                                            style={{color: color}}

                                                                        />,
                                                                        color: 'warning',
                                                                    }}
                                                                />
                                                                <Tab.Screen
                                                                    name="Likes"
                                                                    component={DemoScreen}
                                                                    options={{
                                                                        title: 'Likes',
                                                                        icon: ({focused, color, size}) => <HMIcon
                                                                            type="AntDesign" name="hearto"
                                                                            size={size}
                                                                            color={color}
                                                                            style={{color: color}}

                                                                        />,
                                                                        color: 'danger',
                                                                    }}
                                                                />
                                                                <Tab.Screen
                                                                    name="Settings"
                                                                    component={DemoScreen}
                                                                    options={{
                                                                        title: 'Settings',
                                                                        icon: ({focused, color, size}) => <HMIcon
                                                                            type="AntDesign" name="setting"
                                                                            size={size}
                                                                            color={color}
                                                                            style={{color: color}}

                                                                        />,
                                                                        color: 'success',
                                                                    }}
                                                                />
                                                                <Tab.Screen
                                                                    name="Likes1"
                                                                    component={DemoScreen}
                                                                    options={{
                                                                        title: 'Likes1',
                                                                        icon: ({focused, color, size}) => <HMIcon
                                                                            type="AntDesign" name="hearto"
                                                                            size={size}
                                                                            color={color}
                                                                            style={{color: color}}

                                                                        />,
                                                                        color: 'danger',
                                                                    }}
                                                                />
                                                                <Tab.Screen
                                                                    name="Settings1"
                                                                    component={DemoScreen}
                                                                    options={{
                                                                        title: 'Settings1',
                                                                        icon: ({focused, color, size}) => <HMIcon
                                                                            type="AntDesign" name="setting"
                                                                            size={size}
                                                                            color={color}
                                                                            style={{color: color}}

                                                                        />,
                                                                        color: 'success',
                                                                    }}
                                                                />*/}
                                                        </Tab.Navigator>
                                                    </View>
                                            )

                                    }

                                    {
                                        this.state.isLoading ?
                                            <DialogLoadingCustomize/>
                                            : null
                                    }


                                    {
                                        this.props.NoInternetDialog ?
                                            <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                                    }

                                </View>
                                {
                                    // this.state.showDialogDate ?
                                    //     <HMDialogSelectDate
                                    //         DateTo={endDate}
                                    //         DateFrom={beginDate}
                                    //         onPressOk={this.setDate}
                                    //         onPressCancel={() => {
                                    //             this.setState({
                                    //                 showDialogDate: false
                                    //             })
                                    //         }}
                                    //     />
                                    //
                                    //     :
                                    //
                                    //     null
                                }
                            </KeyboardAvoidingView>
                        </View>
                }

            </View>
        );
    }

    async getDataSplash() {
        container.setState({
            noShowMessage: false
        })

        let dataSplash = container.props.DataSplashSatiaScreen
        if (dataSplash.Connection) {
            //if (global.GoOfflineToMain) {
            container.getDataServerSplash()

            //   }

            // await AsyngStorageClass.setAsyng("splashSatiaWP" + global.IdCity, dataSplash.results);
            //  await AsyngStorageClass.setAsyng("splashSatia" + global.IdCity, dataSplash.results);
        }
    }

    getDataServerSplash() {
        //   let dataSplash = container.props.DataSplashSatiaScreen

        let {beginDate, endDate} = container.props.DataSplashSatiaScreen;
        let paramss = {
            "token": container.props.token,
            "beginDate": beginDate,
            "endDate": endDate,
            "id": 1,
            "lang": i18n.locale,
            "imei": 0,
            "token_fb": container.props.token_fb,
            'Account': container.props.Account ? container.props.Account : null,
        };
        store.dispatch(callWebserviceSplash(paramss, typeExport.TypeGetAllData, typeExport._GET, "MainScreen"))
    }

    goScreen(route, item, position) {
        let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)

        container.setState({isLoading: false})
        NavigationService.navigateParams(route, {
            position: position,
            typeComponent: checkLogin ? "Operation" : null,
            item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : item,
            data: item,
            type: route
        })
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        })
    }

    switchComponents(item, key, navigation, route) {


        switch (item.type) {

            case 1:
                return <AddTaskOperationSatiaScreen Extras={item}
                                                    data={item} item={item}

                                                    navigation={navigation}
                />;
            // Toast.show({
            //     text1: 'Hello',
            //     text2: 'This is some something 👋'
            // })                                                                            //alert(global.ref_toast)

            // NavigationService.navigateParams("AddTaskOperationSatiaScreen", {
            //     //  NavigationService.navigateParams("ListUserChatScreen", {
            //     // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
            //     data: item,
            //     item: item,
            //     Extras: item,
            // })
            //   break;

            case 2:
                return <ListTaskOperationSatiaScreen Extras={item}
                                                     data={item} item={item}
                                                     navigation={navigation}

                />;
            // NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
            //     Extras: item,
            //     // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
            //     data: item, item: item,
            // })
            // break;
            case 3:
                return <ListTaskOperationSatiaScreen Extras={item}
                                                     data={item} item={item}
                                                     navigation={navigation}

                />;

            // NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
            //     Extras: item,
            //     // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
            //     data: item, item: item,
            // })
            // break;

            case 4:
                return <ListTaskOperationSatiaScreen Extras={item}
                                                     data={item} item={item}
                                                     navigation={navigation}

                />;

            // NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
            //     Extras: item,
            //     // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
            //     data: item, item: item,
            // })
            // break;

            case 5:
                // alert("djhbghb")
                return <ListReportTaskOperationSatiaScreen
                    Extras={item}
                    data={item} item={item}
                    navigation={navigation}

                />;

            // NavigationService.navigateParams("ListReportTaskOperationSatiaScreen", {
            //     Extras: item,
            //     // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
            //     data: item, item: item,
            // })
            // break;
            case 6:
                return <ListTaskOperationSatiaScreen
                    Extras={item}
                    data={item} item={item}
                    navigation={navigation}

                />;

            // NavigationService.navigateParams("ListTaskOperationSatiaScreen", {
            //     Extras: item,
            //     // NavigationService.navigateParams("ListOperatorFireTasksOperationSatiaScreen", {
            //     data: item, item: item,
            // })
            // break;


            default:
                return <AddTaskOperationSatiaScreen Extras={item}
                                                    data={item} item={item}
                                                    navigation={navigation}

                />;
        }


    }

    async getDataTabBar(dataTab) {
        let {Extras, data, type, mode} = this.props.route && this.props.route.params ? this.props.route.params : this.props;
        let after = "0000-00-00";
        //   this.props.callService(urlListTaskOperationSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListTaskOperationSatiaScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListTaskOperationSatiaScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListTaskOperationSatiaScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListTaskOperationSatiaScreen, _GET, page, 10)
  */

        let paramss = {

            "lang": i18n.locale,
            "token": store.getState().reducerSplashSatiaScreen.token,
            "page": this.props.reducerListTaskOperationSatiaScreen.page,
            "type": dataTab.type ? dataTab.type : null,
            "id": type && dataTab ? dataTab.id : null,
            "name": type && dataTab ? dataTab.name : null,

            "month": this.state.Period,
            //  beginDate=1399/5/24&endDate=1399/6/13
            //     DateTo={this.state.DateTo}
            // DateFrom={this.state.DateFrom}
            // "beginDate": this.state.DateTo,
            // "endDate": this.state.DateFrom,
            "beginDate": this.state.DateFrom,
            "endDate": this.state.DateTo,
            "typeSort": this.state.typeSort,
            "typeOrder": this.state.typeOrder,
            "listFilter": this.state.arraySelected,
            "searchText": this.state.searchText,
        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {

            this.props.callService(typeExport._baseUrlSatia + (Extras.type == 4 ? "operator_tk/myTasksCreator" : "operator_tk/myTasks"), paramss, typeExport.TypeGetListTaskOperationSatiaScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }
}

const DemoScreen = ({route}) => (
    <View style={styles.screen}>
        <Text>{route.name}</Text>
    </View>
);
const styles = StyleSheet.create({
    screen: {
        width: '100%',
        height: '100%',
        flex: 6,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
const mapStateToProps = (state) => {

    return {
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,
        token: state.reducerSplashSatiaScreen.token,
        token_fb: state.reducerSplashSatiaScreen.token_fb,
        reducerListTaskOperationSatiaScreen: state.reducerListTaskOperationSatiaScreen,
        // CartList: state.reducerSplashGetAllData.CartList,
        // PriceAll: state.reducerSplashGetAllData.PriceAll,
        // Rtl: state.reducerSplashGetAllData.Rtl,
        // DataSplashSatiaScreen: state.reducerSplashGetAllData
    }
}
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceAddCart: (data) => dispatch(serviceActionAddCart(data)),
        //  callServiceSubCart: (data) => dispatch(serviceActionSubCart(data)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TasksOperationSatiaScreen);
